<template>
	<div id="partners">
		<div class="partners_banner" v-cloak></div>
		<div class="hezuotop">
			<h1 class="hezuotitle">合作银行</h1>
			<p class="hezuotext">本公司研发的"农产品电子追溯+智慧支付系统"在浙江省各地区100多个农贸及农批市场投入使用,并凭借多模式、高效率、低成本之优势得到了用户的广泛认同</p>
			<div class="allyuanbox">
				<div :class="['yuanbox',sclick?'active':'']" @click="sclicks(0)">
					<div class="yuan">农商银行</div>
					<div class="xian"></div>
				</div>
				<div :class="['yuanbox',!sclick?'active':'']" @click="sclicks(1)">
					<div class="yuan ">更多银行</div>
					<div class="xian"></div>
				</div>

			</div>
		</div>
		<div class="swiper-container" id="bank_swiper">
			<div class="swiper-wrapper">
				<div class="swiper-slide">
					<div class="hezuobottom" v-show="sclick">
						<div class="l">
							<ul>
								<li class="ml78">东阳农商银行</li>
								<li class="ml28">永康农商银行</li>
								<li>成泰农商银行</li>
								<li class="ml28">武义农商银行</li>
								<li class="ml78">浦江农商银行</li>
							</ul>
						</div>
						<div :class="['c']">
							<img src="static/img/img_logo_nsyh.png" alt="" />
						</div>
						<div class="r">
							<li class="mr78">磐安农商银行</li>
							<li class="mr28">临海农商银行</li>
							<li>温岭农商银行</li>
							<li class="mr28">路桥农商银行</li>
							<li class="mr78">玉环农商银行</li>
						</div>
					</div>
				</div>
				<div class="swiper-slide">
					<div class="hezuobottom " v-show="sclick">
						<div class="l">
							<ul>
								<li class="ml78">定海农商银行</li>
								<li class="ml28">岱山农商银行</li>
								<li>吴兴农商银行</li>
								<li class="ml28">德清农商银行</li>
								<li class="ml78">安吉农商银行</li>
							</ul>
						</div>
						<div :class="['c',sclick?'active':'']">
							<img src="static/img/img_logo_nsyh.png" alt="" />
						</div>
						<div class="r">
							<li class="mr78">南浔农商银行</li>
							<li class="mr28">长兴农商银行</li>
							<li style="visibility: hidden;">吴兴农商银行</li>
							<li style="visibility: hidden;" class="ml28">德清农商银行</li>
							<li style="visibility: hidden;" class="ml78">安吉农商银行</li>
						</div>
					</div>
				</div>
			</div>
			<div class="swiper-button-next"></div>
			<div class="swiper-button-prev"></div>
		</div>
		<div class="hezuobottom hezuobottom1" v-show="!sclick">
			<div class="l">
				<ul>
					<li class="ml78">工商银行龙湾支行</li>
					<li class="ml28">工商银行椒江支行</li>
					<li>工商银行武义支行</li>
					<li class="ml28">建设银行舟山分行</li>
					<li class="ml78">建设银行义乌支行</li>
				</ul>
			</div>
			<div class="c active">
				<img src="static/img/img_logo_qtyh.png" alt="" />
			</div>
			<div class="r">
				<li class="mr78">建设银行杭州分行</li>
				<li class="mr28">建设银行嘉兴分行</li>
				<li>建设银行桐乡支行</li>
				<li class="mr28">农业银行桐乡支行</li>
				<li class="mr78">邮政储蓄银行丽水分行</li>
			</div>
		</div>
		<div class="partners_firm">
			<div class="partners_firmTitle">合作厂商</div>
			<div class="partners_firmLists">
				<div class="partners_firmList" v-for="(item,index) in firms" @click="gotoLink(item.hr)" :style="{backgroundImage:'url(' + item.img_url + ')'}">
					<div class="partners_firmName">{{item.title}}</div>
					<div class="partners_firmIntro">{{item.content}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.min.css'
	export default {
		metaInfo() {
			return {
				meta: [{
						name: 'renderer',
						content: 'http://www.ax168.com/partners'
					},
					{
						name: 'partners',
						content: '合作伙伴。合作银行、合作厂商'
					},
					{
						name: 'keywords',
						content: '智慧农贸,智慧市场，智慧菜场，电子追溯，电子支付，智慧农贸,数字农贸,智慧农贸市场,智慧城市,菜篮子,农贸市场管理,农贸市场管理系统,溯源单子秤,智慧菜场,智慧菜市场,智慧市场,农贸市场智慧化建设方案,智慧微菜场,农贸市场管理软件,智慧农贸电子秤,农贸市场管理软件,菜市场管理系统,菜市场管理软件,新型农贸市场,O2O菜场，重要产品追溯系统,智慧农贸信息化平台,食品追溯监管系统,企业产品追溯系统,农产品追溯系统,仓储配送系统,智慧支付系统'
					},
					{
						name: 'description',
						content: '浙江安宣信息技术有限公司，国家高新技术企业，咨询热线0571-87357305，智慧菜场、智慧农贸、智慧农批、智慧市场、食品安全信息化监管和食品安全追溯平台以及农贸O2O电商平台。'
					}
				]
			}
		},
		data() {
			return {
				//				yinhang:{
				//					a:[东阳农商银行,永康农商银行,城泰农商银行,武义农商银行,浦江农商银行],
				//					b:[]
				//				},
				xuanzhuan: false,
				sclick: true,
				myone: '0',
				mycompantets: '0',
				bankType: 0, //0农商银行，1其他银行
				firms: [{
						id: 1,
						img_url: 'http://img.anxuan360.com/FphgNygIiMbUmOOk6-m8SB9Wc1Ka',
						title: "杭州天迈生物科技有限公司",
						content: "是国内领先的食品安全快速检测综合解决方案的提供商与服务商。公司位于杭州市滨江区天和高科技产业园，是一家拥有自主知识产权的科技创新型企业。",
						hr: 'http://hztianmai.foodmate.net/introduce/'
					},
					{
						id: 2,
						img_url: 'http://img.anxuan360.com/FvzhPRCLVoRpInjIFpr_DTHCvPtH',
						title: "上海瑞鑫科技仪器有限公司",
						content: '上海瑞鑫科技仪器有限公司成立于2000年，是一家致力于食品安全快速检测仪器、智能仪表、快速检测试剂及相关软件开发和生产的高科技民营企业。产品主要销往全国农业局、食品药品监督管理局、农贸市场、食堂、超市等单位。',
						hr: 'http://ruixin111.foodmate.net/buy/'
					},
					{
						id: 3,
						img_url: 'http://img.anxuan360.com/Fm7V7Uv5Sb2VF60BU5h1I0qbI1bB',
						title: "厦门海荭兴仪器股份有限公司",
						content: '海荭兴创立于2007年，是专注于食品安全快速检测与信息化技术应用的高新技术企业。公司集研发、生产、销售、服务于一体，主营业务包括：食品安全快检设备研制、食品安全快检外包服务、食品安全第三方检验检测、食品安全信息化监管系统产品等，并依托中国农科院、厦门大学、华侨大学等科研力量，以及自主创新能力，不断完善“快检一站式服务—第三方检测—大数据分析—物联网食品安全云服务”可持续发展的生态链。',
						hr: 'http://www.xmhhx.com/Skins/Page.aspx?ID=1&Page_Class=3'
					},
					{
						id: 4,
						img_url: 'http://img.anxuan360.com/Fo70V6mCtmO_7EzgI3qnFSpPXd8-',
						title: "厦门绿安仪器有限公司",
						content: '厦门绿安分析仪器有限公司是国内领先的食品安全与环境检测分析仪器供应商，拥有一流的研发、营销、运营服务和供应链团队，致力于业界最前沿的各种分析检测技术研究与应用开发，已研发200多种型号的产品，成为掌握分析仪器前沿技术的制造商之一。我司提供满足全国市场需求的高端分析测量仪器、完善的行业应用解决方案和售后服务。',
						hr: 'http://www.aolksafe.com/index.php'
					},
					{
						id: 5,
						img_url: 'http://img.anxuan360.com/FngO8SvzaTc5oxukZt2w_VN4xaOA',
						title: "宁波美成生物科技有限公司",
						content: '宁波美成生物科技有限公司是ATP荧光检测仪、ATP荧光检测拭子、ATP拭子、无等产品专业生产加工的公司，拥有完整、科学的质量管理体系。',
						hr: 'https://mcswkj123.cn.gongchang.com/'
					},
					{
						id: 6,
						img_url: 'http://img.anxuan360.com/FinxJQTw6w2byGsn59InwO9aTOIH',
						title: "厦门斯坦道科学仪器股份有限公司",
						content: '2002年，厦门斯坦道科学仪器股份有限公司成立于具有浓厚创新氛围的厦门火炬高新区，拥有较完善的研发、生产、质检、营销和技术服务团队。',
						hr: 'http://spaq.com.cn/index.aspx'
					},
					{
						id: 7,
						img_url: 'http://img.anxuan360.com/FlgVvvGMRL2aC6BnZkgDEMxv2R_F',
						title: "广州达元食品安全技术有限公司",
						content: '是国内领先的食品安全快速检测综合解决方案的提供商与服务商。公司位于杭州市滨江区天和高科技产业园，是一家拥有自主知识产权的科技创新型企业。',
						hr: 'http://www.chinafst.cn/CH/index.php'
					},
					{
						id: 8,
						img_url: 'http://img.anxuan360.com/Fi-uAIDYV5O03pt6UA2JemTs8X6R',
						title: "厦门市藤蔓生物科技有限公司",
						content: ' 厦门藤蔓生物科技有限公司是一家以农产品追溯体系、食品安全监测仪器等一系列食品安全为经营主导的企业。公司致力于食品安全检测仪器、农产品追溯体系等高新科技在中国的创新开发应用和推广。',
						hr: 'http://tengman.foodmate.net/'
					},
					{
						id: 9,
						img_url: 'http://img.anxuan360.com/FgYMBwUrzZAI1s-JGG0Br3phw65X',
						title: "南京普仪德食安仪器科技有限公司",
						content: '南京普仪德食安仪器检测科技有限公司、南京普仪德食安快检技术服务有限公司，坐落于风景秀丽的玄武湖畔，多年来依托于总公司的研发技术力量，推动食品安全的快速检测先进手段，致力于食品安全检测领域的技术应用。',
						hr: 'http://njpued.foodmate.net/'
					},
					{
						id: 10,
						img_url: 'http://img.anxuan360.com/FnzVZm3kPTYLXeBEQoiKsfPElEI8',
						title: "广州安诺科技股份有限公司",
						content: '广州安诺科技股份有限公司（安诺科技）是一家致力于食品安全监管的高新技术企业，为广东省药品检验所的快检技术专利授权合作单位。安诺科技主营业务为快筛快检技术研发及推广，包括第三方检测服务（快速检测、法定检验）、快筛试剂盒、快检仪器设备、快检车、智能实验室以及食品安全溯源系统，服务于全国各级食品安全监管部门、企事业单位。',
						hr: 'http://www.quickcheck.com.cn/about.aspx?cateid=67'
					}
				],
			}
		},
		activated() {
			document.documentElement.style.fontSize = "";
		},
		mounted: function() {
			//bank轮播
			var that = this
			var bankSwiper = new Swiper('#bank_swiper', {
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				spaceBetween: 30,
				speed: 1200
			})
			this.dli = document.querySelectorAll(".hezuobottom li");
			this.dimg = document.querySelectorAll(".hezuobottom .c");
			window.addEventListener('scroll', this.menu)
		},
		methods: {
			sclicks(data) {
				if(data) {
					this.sclick = false
				} else {
					this.sclick = true
				}
			},
			destroyed() {
				window.removeEventListener('scroll', this.menu);
			},
			menu() {
				if(this.dimg[0].getBoundingClientRect().top - document.documentElement.clientHeight < -50) {
					this.dimg[0].classList.add("active");
					this.dimg[1].classList.add("active");
				}
				for(var i = 0; i < this.dli.length; i++) {
					if(this.dli[i].getBoundingClientRect().top - document.documentElement.clientHeight < -50) {
						this.dli[i].classList.add("active");
					}
				}

			},
			// 选择银行类型
			chooseBankType: function(type) { //0农商银行，1其他银行
				this.bankType = type;
			},
			// 点击跳转页面
			gotoLink: function(url) {
				window.open(url);
			}
		},
		components: {}
	}
</script>

<style>
	@import url('../css/partners.css');
	[v-cloak] {
		display: none !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/partners.vue